import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门排行</h2>
            <p className="mt-1 text-sm text-foreground-500">根据阅读热度实时更新，发现大家都在追的漫画</p>
          </div>
          <span className="hidden sm:flex items-center gap-1 text-xs text-foreground-400">
            <i className="ri-time-line"></i>每小时更新
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="group relative bg-background-50 rounded-xl p-4 border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="absolute top-3 left-3 w-7 h-7 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xs font-bold">
                {item.rank}
              </div>
              <div className="mt-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">{item.category}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">{item.author}</p>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
                <div className="mt-3 flex flex-wrap items-center gap-1.5">
                  {item.tags.map((tag) => (
                    <span key={tag} className="text-[11px] px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 font-medium">{tag}</span>
                  ))}
                </div>
                <div className="mt-3 flex items-center gap-1 text-accent-600">
                  <i className="ri-fire-line text-sm"></i>
                  <span className="text-sm font-semibold">{item.heat}</span>
                  <span className="text-xs text-foreground-400">热度</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <button className="px-6 py-2.5 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer">
            查看更多排行 <i className="ri-arrow-right-line ml-1"></i>
          </button>
        </div>
      </div>
    </section>
  );
}